import { render, staticRenderFns } from "./OrdenVentaFilters.vue?vue&type=template&id=f0b98ec2&scoped=true&"
import script from "./OrdenVentaFilters.vue?vue&type=script&lang=js&"
export * from "./OrdenVentaFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrdenVentaFilters.vue?vue&type=style&index=0&id=f0b98ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b98ec2",
  null
  
)

export default component.exports